import React from "react"
import {
  Box,
  Grid,
  Container,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@material-ui/core"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { Link } from "gatsby-theme-material-ui"
const queryString = require("query-string")

const Comp = () => {
  const data = useStaticQuery(graphql`
    query HeroQuery {
      desktop: file(
        relativePath: { eq: "home/Custo_Lifestyle_TV_desktop.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 1920) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mobile: file(relativePath: { eq: "home/Custo_Lifestyle_TV_mobile.jpg" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 800) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      categories: allHasura {
        category {
          id
          name
          product_room_categories {
            id
            product {
              id
              slug
              style {
                id
                name
              }
              presets {
                id
                size
              }
            }
          }
        }
      }
    }
  `)

  const theme = useTheme()
  const smaller = useMediaQuery(theme.breakpoints.down("xs"))

  return smaller ? (
    <Box>
      <Box py={[2, 16, 24, 36]} textAlign={smaller ? "center" : "left"}>
        <Container maxWidth="md">
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h3" component="h1" gutterBottom>
                Custo fits to your home and the items you love
              </Typography>
              <Typography variant="body1" gutterBottom paragraph>
                Custo is a unique platform that empowers you to customise and
                personalise your furniture to fit your space, lifestyle and
                budget!
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                component={Link}
                onClick={() =>
                  navigate(
                    queryString.stringifyUrl(
                      {
                        url: "/shop",
                        query: {
                          categories: data.categories.category.map(c =>
                            c.name.toLowerCase()
                          ),
                          styles: ["air", "cube", "stacc"],
                        },
                      },
                      { arrayFormat: "bracket" }
                    )
                  )
                }
                style={{ color: "white" }}
              >
                Shop
              </Button>
              <Button
                variant="text"
                color="secondary"
                size="large"
                component={Link}
                onClick={() => {
                  typeof window !== `undefined` &&
                    window.Intercom &&
                    window.Intercom("show")
                }}
                style={{ color: theme.palette.primary }}
              >
                Chat With Designer
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <video
        style={{
          zIndex: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
        muted
        autoPlay
        loop
        inline
        playsInline
      >
        <source
          src="/stacc/intro-mobile.mp4"
          type="video/mp4"
          media="all and (max-width: 480px)"
        />
      </video>
    </Box>
  ) : (
    <Box position="relative" minHeight="calc(9*100vw/16)">
      <video
        style={{
          zIndex: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
        }}
        muted
        autoPlay
        loop
        inline
        playsInline
      >
        <source
          src="/stacc/intro-desktop.mp4"
          type="video/mp4"
          media="all and (min-width: 480px)"
        />
      </video>
      <Box
        py={[2, 2, 8, 24, 36]}
        textAlign={"left"}
        style={{
          position: "absolute",
          zIndex: 1,
          width: "100%",
          height: "100%",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item xs={7} md={5} lg={5} xl={5}>
              <Typography
                variant="h3"
                component="h2"
                style={{
                  color: "white",
                  textShadow: "0px 0px 50px rgba(0,0,0,0.5)",
                }}
                gutterBottom
              >
                Custo fits to your home and the items you love
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                paragraph
                style={{
                  color: "white",
                  textShadow: "0px 0px 20px rgba(0,0,0,1)",
                }}
              >
                Custo is a unique platform that empowers you to customise and
                personalise your furniture to fit your space, lifestyle and
                budget!
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                size="large"
                component={Link}
                onClick={() =>
                  navigate(
                    queryString.stringifyUrl(
                      {
                        url: "/shop",
                        query: {
                          categories: data.categories.category.map(c =>
                            c.name.toLowerCase()
                          ),
                          styles: ["air", "cube", "stacc"],
                        },
                      },
                      { arrayFormat: "bracket" }
                    )
                  )
                }
                style={{ color: "white" }}
              >
                Shop
              </Button>
              <Button
                variant="text"
                color="secondary"
                size="large"
                component={Link}
                onClick={() => {
                  typeof window !== `undefined` &&
                    window.Intercom &&
                    window.Intercom("show")
                }}
                style={{ color: theme.palette.primary }}
              >
                Chat With Designer
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  )
}

export default Comp
